// Customer dashboard layout — chrome lives in <AppShell>.
import AppShell from './AppShell';

export default function DashboardLayout() {
  return <AppShell />;
}
